import { render, staticRenderFns } from "./LiveStreamAnnouncementIndex.vue?vue&type=template&id=1fadc9db&scoped=true&"
import script from "./LiveStreamAnnouncementIndex.vue?vue&type=script&lang=js&"
export * from "./LiveStreamAnnouncementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fadc9db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fadc9db')) {
      api.createRecord('1fadc9db', component.options)
    } else {
      api.reload('1fadc9db', component.options)
    }
    module.hot.accept("./LiveStreamAnnouncementIndex.vue?vue&type=template&id=1fadc9db&scoped=true&", function () {
      api.rerender('1fadc9db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/LiveStream/Announcements/LiveStreamAnnouncementIndex.vue"
export default component.exports